// Shared feature definitions for all plan-related pages
// This ensures consistency across Pricing Page, Plans Page, and Edit Plans Page

export const PLAN_FEATURES = {
  platform_security: [
    { key: "custom_branding", label: "Custom Branding" },
    { key: "multiple_branches", label: "Multiple Branches" },
    { key: "role_based_access", label: "Role-Based Access Control" },
    { key: "activity_logs", label: "Activity Logs" },
    { key: "ip_restrictions", label: "IP Restrictions" },
    { key: "two_factor_auth", label: "Two-Factor Authentication" },
    { key: "roles_and_access", label: "Access Control Management" },
  ],

  employee_core_management: [
    { key: "document_upload", label: "Employee Document Upload" },
    { key: "department_mapping", label: "Department Mapping" },
    { key: "bulk_import", label: "Bulk Employee Import" },
    { key: "excel_pdf_export", label: "Excel & PDF Export" },
    { key: "employee_portal", label: "Employee Portal Access" },
    { key: "event_management", label: "Event Management"},
  ],

  leave_attendance: [
    { key: "web_punch", label: "Web Punch" },
    { key: "geo_fencing", label: "Geo-Fencing" },
    { key: "biometric_integration", label: "Biometric Integration" },
    { key: "multi_shift_support", label: "Multi-Shift Support" },
    { key: "regularization_requests", label: "Attendance Regularization Requests" },
    { key: "late_early_punch_rules", label: "Late / Early Punch Rules" },
    { key: "performance_management", label: "Performance Management" },
    { key: "performance_ratings", label: "Employee Performance Ratings" },
    { key: "overtime_management", label: "Overtime Management" },
  ],

  payroll_loan_management: [
    { key: "basic_leave_management", label: "Basic Leave Management" },
    { key: "custom_leave_management", label: "Advanced Leave Management" },
    { key: "leave_encashment", label: "Leave Encashment" },
    { key: "payroll_analytics", label: "Payroll Analytics" },
    { key: "basic_payroll", label: "Manual Payroll Processing" },
    { key: "advanced_payroll", label: "Automated Payroll Processing" },
    { key: "bank_advice", label: "Bank Advice Generation" },
    { key: "multi_bank_accounts", label: "Multiple Bank Accounts" },
    { key: "loan_management", label: "Employee Loan & Advance Management" },
    { key: "form_16_generation", label: "Form 16 Generation" },
  ],
};

// Get all features as a flat array
export const getAllFeatures = () => {
  return [
    ...PLAN_FEATURES.platform_security,
    ...PLAN_FEATURES.employee_core_management,
    ...PLAN_FEATURES.leave_attendance,
    ...PLAN_FEATURES.payroll_loan_management,
  ];
};

// Get only enabled features for a plan (used in pricing cards)
export const getEnabledFeatures = (planFeatures) => {
  const allFeatures = getAllFeatures();
  return allFeatures.filter(feature => planFeatures[feature.key] === true);
};
